import { createContext, useContext } from "react";
import type { ChatContext as ChatCtxType } from "./types";
import type { ProactiveMessage } from "./proactiveMessage";

export type ChatStateContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  context: ChatCtxType;
  initialMessage: string | null;
  setInitialMessage: (m: string | null) => void;
  proactive: ProactiveMessage | null;
};

export const ChatStateContext = createContext<ChatStateContextValue | null>(null);

export function useChatState() {
  const value = useContext(ChatStateContext);
  if (!value) throw new Error("useChatState must be used within ChatProvider");
  return value;
}
